import { Button, Flex, Icon, Icons, type TableColumnType } from "@ir/ui";
import {
  MasterDataRetailerMatchRule,
  type IMasterDataRetailerMatchRule,
  type MasterDataRetailerMatchRule as MasterDataRetailerMatchRuleEntity,
} from "@src/domain/entities/masterData";
import { Permissions } from "@src/domain/permissions";
import HasAnyPermission from "@src/presentation/components/permissions/HasAnyPermission";
import { MASTER_DATA_COLUMN_VERTICAL_ALIGN } from "./masterDataTable.shared";

export interface MasterDataRetailerMatchRuleRow
  extends IMasterDataRetailerMatchRule {
  key: string;
}

export function mapMatchRulesToRows(
  rules: MasterDataRetailerMatchRuleEntity[],
): MasterDataRetailerMatchRuleRow[] {
  return rules.map((entity) => ({
    ...MasterDataRetailerMatchRule.toJSON(entity),
    key: String(entity.ruleId),
  }));
}

export function indexMatchRulesById(
  rules: MasterDataRetailerMatchRuleEntity[],
): Map<number, MasterDataRetailerMatchRuleEntity> {
  const map = new Map<number, MasterDataRetailerMatchRuleEntity>();
  for (const rule of rules) {
    map.set(rule.ruleId, rule);
  }
  return map;
}

export function buildMatchRuleActionsColumn(
  onEdit: (entity: MasterDataRetailerMatchRuleEntity) => void,
  rulesById: Map<number, MasterDataRetailerMatchRuleEntity>,
): TableColumnType<MasterDataRetailerMatchRuleRow> {
  return {
    title: "Actions",
    dataIndex: "ruleId",
    key: "actions",
    align: "center",
    fixed: "right",
    verticalAlign: MASTER_DATA_COLUMN_VERTICAL_ALIGN,
    width: 80,
    cellRender: (value: unknown) => {
      const id = Number(value);
      const rule = rulesById.get(id);
      if (!rule) return null;
      return (
        <HasAnyPermission requiredPermissions={[Permissions.MASTER_DATA_EDIT]}>
          <Flex align="center" justifyContent="center">
            <Button
              size="small"
              variant="outline"
              color="grey"
              aria-label={`Edit ${rule.matchPattern}`}
              onPress={() => onEdit(rule)}
            >
              <Icon name={Icons.Edit} size="small" />
            </Button>
          </Flex>
        </HasAnyPermission>
      );
    },
  };
}
